<script>
	import { onMount } from 'svelte';
	import { projectIds, loadProjects } from './stores/projects.js'; 
	
	$: ids = $projectIds.join( ', ' );
	onMount( loadProjects );
</script>
